import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { apiBaseUrl, apiKey } from "../../../utils/config";

export const updateOpenPosition = createAsyncThunk(
  'openPositions/updateOpenPosition',
  async (orderPayload, { rejectWithValue }) => {
    try {
      let token = localStorage.getItem("token");

      const response = await axios.post(
        `${apiBaseUrl}/trade/update-position`, 
        {
          api_key: orderPayload.api_key,
          account: orderPayload.account,
          positionId: orderPayload.positionId,
          positionById: orderPayload.positionById,
          symbol: orderPayload.symbol,
          volume: orderPayload.volume,
          price: orderPayload.price,
          type: orderPayload.type,
          tp: orderPayload.tp,
          sl: orderPayload.sl, // Fixed: sl was missing from your payload
          comment: ""
        },
        {
          headers: {
            "Trade-Account-Token": token
          }
        }
      );

      // Return API response data
      return response.data; // { message: "Trade successfully updated" }
    } catch (error) {
      console.error("Order API error:", error.response?.data || error.message);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  message: '',
  isLoading: false,
  error: null
};

const updateOpenPositionSlice = createSlice({
  name: 'updateOpenPosition',
  initialState,
  reducers: {
    resetPositionMessage: (state) => {
      state.message = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateOpenPosition.pending, (state) => {
        state.isLoading = true;
        state.error = null; // Reset any previous errors
      })
      .addCase(updateOpenPosition.fulfilled, (state, action) => {
        state.isLoading = false;
        state.message = action.payload.message; // Store success message
      })
      .addCase(updateOpenPosition.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message; // Store error message
      });
  }
});

export const { resetPositionMessage } = updateOpenPositionSlice.actions;

export default updateOpenPositionSlice.reducer;
